<template>
    <el-dialog v-model="dialogShow" :show-close="showClose" :close-on-click-modal="false" width="90%" class="closereg-dialog" :before-close="closeDialog"
    >
        <template v-if="$t('lang') == 'en'">
            <p class="p2">Pre-registration is closed, please scan the code to register as a visitor of SIAL Shanghai 2025!</p>
            <div class="ewm"><img src="https://imgs.sialchina.cn/uploads/editor/images/20250518/a4336f3526fab2dced0cda99907dec22.png"></div>
            <p class="p2">This exhibition is a professional food and beverage trade show, open exclusively to industry professionals. Individuals under 18 and non-professionals over 70 are restricted to enter the venue.</p>
        </template>
        <template v-else>
            <!-- <p class="p1">感谢您的关注！</p> -->
            <p class="p2">此注册通道已关闭，请扫描下方二维码进行现场观众注册！</p>
            <div class="ewm"><img src="https://imgs.sialchina.cn/uploads/editor/images/20250518/676d121779ad40818ffa7e60113796e8.png"></div>
            <p class="p2">本展会为专业食品饮料展，仅对专业人士开放，不满18周岁未成年人和70周岁及以上的非专业人士无法入场。</p>
        </template>
    </el-dialog>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
export default {
    props: {
        dialogVisible: {
            type: Boolean,
            default: false,
        },
        showClose: {
            type: Boolean,
            default: false
        },
        redirectUrl: {
        }
    },
    emits: ["closeDialog"],
    setup(props, ctx) {
        const store = useStore();
        const router = useRouter();
        const dialogShow = computed({
            get() {
                return props.dialogVisible;
            },
            set(val) {
                return val;
            },
        });
        const closeDialog = ()=>{
            props.redirectUrl && router.push(props.redirectUrl)
            ctx.emit("closeDialog", false)
        }

        return {
            dialogShow,
            closeDialog
        }
    }
}
</script>

<style lang="less">
.closereg-dialog {
    background: #f7cb6a url('@/assets/images/kv2.png') no-repeat right -30px bottom -20px;
    padding: 15px 10px;
    border-radius: 15px;
    max-width: 768px;
    color: #333;
    
    .el-dialog__header {
        padding: 0 !important;
    }   
    .el-dialog__body {
        color: #333;
        min-height: 200px;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .p1 {
        font-size: 18px;
        margin-bottom: 15px;
    }
    .p2 {
        font-size: 16px;
        line-height: 1.8;
    }
    .ewm {
        border: 1px solid #ec664e;
        width: 156px;
        background-color: #fff;
        margin: 20px 0;
        max-width: 40%;
        img {
            display: block;
            width: 100%;
        }
    }
}

@media screen and (max-width: 768px) {
    .closereg-dialog {
        padding: 0;
    }
}
</style>